import WorkorderChecklistFooter from '@/components/Movements/WorkOrders/WorkorderChecklist/ChecklistFooter';
import WorkorderChecklistRequestServiceCreateModal from '@/components/Movements/WorkOrders/WorkorderChecklist/ChecklistRequestServiceCreateModal';
import { useWorkorderChecklistContext } from '@/components/Movements/WorkOrders/WorkorderChecklist/WorkorderChecklistProvider';
import { WorkorderChecklistItemType } from '@/components/Movements/WorkOrders/WorkorderChecklist/WorkorderChecklistProvider/WorkorderChecklistProvider.types';
import {
  DefaultRouteTabs,
  DeleteIcon,
  EditIcon,
  Group,
} from '@/components/_common';
import {
  useWorkOrderChecklistRequestServiceList,
  useWorkOrderChecklistRequestServiceRemove,
} from '@/core/domain/workorder/WorkOrdersChecklist/WorkOrdersChecklist.hooks';
import { WorkOrderChecklistRequestService } from '@/core/domain/workorder/WorkOrdersChecklist/WorkOrdersChecklist.types';
import { useDisclosure } from '@/hooks';
import useChecklistValidRoutes from '@/hooks/useChecklistValidRoutes';
import { PageProps } from '@/types/PageProps';
import { Button, Modal, Table } from 'antd';
import { ColumnsType } from 'antd/es/table/interface';
import { useState } from 'react';
import { Helmet } from 'react-helmet';
import { useIntl } from 'react-intl';

const WorkorderChecklistRequestedServicesPage: React.FC<PageProps> = ({
  route,
}) => {
  const intl = useIntl();
  const { checklistItemId, checklistItemType, workorderId, boschChecklist } =
    useWorkorderChecklistContext();
  const [modalOpened, modalAction] = useDisclosure(false, {
    onClose: () => setServiceSelected(undefined),
  });
  const [serviceSelected, setServiceSelected] =
    useState<WorkOrderChecklistRequestService>();

  const { data, isLoading } = useWorkOrderChecklistRequestServiceList({
    diagnosticId:
      checklistItemType == WorkorderChecklistItemType.Diagnostic
        ? checklistItemId
        : undefined,
    workOrderComplementId:
      checklistItemType == WorkorderChecklistItemType.Workorder
        ? checklistItemId
        : undefined,
  });

  const routeParent = useChecklistValidRoutes({
    route,
    checklistItemType,
    workorderId,
    boschChecklist,
  });

  const requestServiceRemove = useWorkOrderChecklistRequestServiceRemove();

  const confirmRemove = (item: WorkOrderChecklistRequestService) => {
    Modal.confirm({
      title: 'Remoção do serviço solicitado',
      content: `Tem certeza que deseja remover o serviço "${item.requestedService}"?`,
      okButtonProps: { danger: true },
      okText: 'Remover',
      onOk: () => requestServiceRemove.mutateAsync(item.id),
    });
  };

  const columns: ColumnsType<WorkOrderChecklistRequestService> = [
    {
      dataIndex: 'requestedService',
      title: 'Serviço solicitado',
      width: 200,
    },
    {
      dataIndex: 'comments',
      title: 'Observação',
      width: 200,
    },
    {
      title: 'Ação',
      align: 'right',
      width: 100,
      fixed: 'right',
      render: (_, item) => (
        <Group position="right" gap={16}>
          <EditIcon
            iconProps={{
              onClick: () => {
                setServiceSelected(item);
                modalAction.open();
              },
            }}
          />

          <DeleteIcon onClick={() => confirmRemove(item)} />
        </Group>
      ),
    },
  ];

  return (
    <DefaultRouteTabs
      route={routeParent}
      baseKey={String(checklistItemId)}
      basePath={`/app/movements/workorderChecklist/${checklistItemId}`}
      extra={
        <Button block onClick={modalAction.open} type="primary">
          Adicionar serviço
        </Button>
      }
    >
      <Helmet title={intl.formatMessage({ id: route.name })} />

      <Table
        dataSource={data}
        columns={columns}
        loading={isLoading}
        pagination={false}
        className="table-break-word"
      />

      <WorkorderChecklistFooter />

      <WorkorderChecklistRequestServiceCreateModal
        open={modalOpened}
        onCancel={modalAction.close}
        requestService={serviceSelected}
      />
    </DefaultRouteTabs>
  );
};

export default WorkorderChecklistRequestedServicesPage;
